<template>
  <div
    id="m_header_topbar"
    class="m-topbar  m-stack m-stack--ver m-stack--general m-stack--fluid"
  >
    <div class="m-stack__item m-topbar__nav-wrapper">
      <ul class="m-topbar__nav m-nav m-nav--inline">
        <!-- begin: notifications -->
        <li
          class="m-nav__item m-topbar__notifications
          m-topbar__notifications--img m-dropdown m-dropdown--medium m-dropdown--header-bg-fill m-dropdown--arrow
          m-dropdown--align-right  m-dropdown--notifications"
        >
          <dropdown>
            <template #btn>
              <span
                v-if="numberOfNotifications > 0"
                :class="{ 'm-nav__link-badge m-badge m-badge--dot m-badge--dot-small m-badge--danger':true,
                          'm-animate-blink':numberOfNotifications > 0}"
              />
              <span
                :class="{ 'm-nav__link-icon':true, 'm-animate-shake':numberOfNotifications > 0}"
                class="m-nav__link-icon"
              >
                <i class="flaticon-alarm" />
              </span>
            </template>
            <template #dropdown>
              <span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust" />

              <div class="m-dropdown__inner">
                <div
                  class="m-dropdown__header m--align-center"
                  :style="'background: url('+cdnURL+'/img/misc/notification_bg_blue.jpg); background-size: cover;'"
                >
                  <span class="m-dropdown__header-subtitle">{{ $t('menus.quick.UserNotifications') }}</span>
                </div>

                <div class="m-dropdown__body">
                  <div class="m-dropdown__content">
                    <div
                      id="notificationList"
                      class="m-scrollable"
                      data-scrollable="true"
                      data-height="250"
                      data-mobile-height="200"
                    >
                      <div class="m-list-timeline m-list-timeline--skin-light">
                        <div class="m-list-timeline__items">
                          <div
                            v-if="numberOfNotifications === 0"
                            class="m-list-timeline__item"
                          >
                            {{ $t('menus.quick.NoNotifications') }}
                          </div>

                          <div
                            v-if="drafts.length > 0"
                            class="m-list-timeline__item"
                          >
                            <span class="m-list-timeline__badge -m-list-timeline__badge--state-success" />
                            <span class="m-list-timeline__text">
                              <router-link
                                :to="getLinkToProperties"
                                class="m-nav-grid__item"
                              >
                                {{ $t('notification.DraftProperty', { total: drafts.length }) }}
                              </router-link>
                            </span>

                            <div class="m-nav__separator m-nav__separator--dashed" />
                          </div>

                          <div
                            v-if="noFeaturedProperty"
                            class="m-list-timeline__item"
                          >
                            <span class="m-list-timeline__badge -m-list-timeline__badge--state-success" />
                            <span class="m-list-timeline__text">
                              <router-link
                                :to="{ name: 'Advertise'}"
                                class="m-nav-grid__item"
                              >
                                {{ $t('notification.NoFeaturedProperty') }}
                              </router-link>
                            </span>
                            <div class="m-nav__separator m-nav__separator--dashed" />
                          </div>

                          <div
                            v-if="noFeaturedBusiness"
                            class="m-list-timeline__item"
                          >
                            <span class="m-list-timeline__badge -m-list-timeline__badge--state-success" />
                            <span class="m-list-timeline__text">
                              <router-link
                                :to="{ name: 'AdvertiseDir'}"
                                class="m-nav-grid__item"
                              >
                                {{ $t('notification.NoFeaturedBusiness') }}
                              </router-link>
                            </span>
                            <div class="m-nav__separator m-nav__separator--dashed" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </dropdown>
        </li>
        <!-- end: notifications -->

        <!-- begin: usermenu -->
        <li
          v-if="user"
          id="userProfileMenu"
          class="m-nav__item m-topbar__user-profile m-topbar__user-profile--img  m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right  m-dropdown--skin-light m-dropdown--profile"
        >
          <dropdown>
            <template #btn>
              <span class="m-topbar__userpic">
                <span class="m-type m--bg-brand">
                  <span class="m--font-light">{{ firstLetter }}</span>
                </span>
              </span>
              <span class="m-topbar__username m--hide">Nick</span>
            </template>
            <template #dropdown>
              <span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust" />
              <div
                class="m-dropdown__inner"
                style="max-height: calc(100vh - 160px);overflow-y: auto;"
              >
                <div
                  class="m-dropdown__header m--align-center"
                  :style="'background-image: url('+cdnURL+'/img/misc/user_profile_bg_blue.jpg); background-size: cover;'"
                >
                  <div class="m-card-user m-card-user--skin-dark">
                    <div class="m-card-user__pic">
                      <span class="m-type m--bg-light">
                        <span class="m--font-brand">{{ firstLetter }}</span>
                      </span>
                    </div>
                    <div class="m-card-user__details">
                      <span
                        class="m-card-user__name m--font-weight-500 m--font-light d-inline-block text-truncate mt-4"
                        style="max-width: 180px;"
                      >{{ fullName }}</span>
                      <div class="clearfix" />
                      <span
                        class="m-card-user__email m--font-weight-300 m--font-light m-link d-inline-block text-truncate"
                        style="max-width: 180px;"
                      >{{ email }}</span>
                      <div class="clearfix" />
                      <span
                        class="m--font-weight-300 m--font-light d-inline-block"
                        style="max-width: 180px;"
                      ><small>{{ login }}</small></span>
                    </div>
                  </div>
                </div>
                <div class="m-dropdown__body">
                  <div class="m-dropdown__content">
                    <ul class="m-nav m-nav--skin-light">
                      <router-link
                        tag="li"
                        :to="{ name: 'Advertise'}"
                        active-class="m-nav__item--active"
                        class="m-nav__item"
                      >
                        <router-link
                          :to="{ name: 'Advertise'}"
                          class="m-nav__link"
                        >
                          <i class="m-nav__link-icon flaticon-line-graph" />
                          <span class="m-nav__link-title">
                            <span class="m-nav__link-wrap">
                              <span class="m-nav__link-text">{{ $t("advertise.AdvertiseProperty") }}</span>
                            </span>
                          </span>
                        </router-link>
                      </router-link>

                      <router-link
                        tag="li"
                        :to="{ name: 'AdvertiseDir'}"
                        active-class="m-nav__item--active"
                        class="m-nav__item"
                      >
                        <router-link
                          :to="{ name: 'AdvertiseDir'}"
                          class="m-nav__link"
                        >
                          <i class="m-nav__link-icon flaticon-line-graph" />
                          <span class="m-nav__link-title">
                            <span class="m-nav__link-wrap">
                              <span class="m-nav__link-text">{{ $t("advertise.AdvertiseDirectoryv2") }}</span>
                            </span>
                          </span>
                        </router-link>
                      </router-link>

                      <li
                        active-class="m-nav__item--active"
                        class="m-nav__item"
                      >
                        <a
                          :href="orderStickerLink()"
                          class="m-nav__link"
                          target="_blank"
                        >
                          <i class="m-nav__link-icon flaticon-notes" />
                          <span class="m-nav__link-title">
                            <span class="m-nav__link-wrap">
                              <span class="m-nav__link-text">{{ $t("advertise.OrderStickers") }}</span>
                            </span>
                          </span>
                        </a>
                      </li>

                      <li
                        active-class="m-nav__item--active"
                        class="m-nav__item"
                      >
                        <a
                          href="https://www.thinkspain.com/advertise/job"
                          class="m-nav__link"
                          target="_blank"
                        >
                          <i class="m-nav__link-icon flaticon-suitcase" />
                          <span class="m-nav__link-title">
                            <span class="m-nav__link-wrap">
                              <span class="m-nav__link-text">{{ $t("advertise.AdvertiseJob") }}</span>
                            </span>
                          </span>
                        </a>
                      </li>

                      <li class="m-nav__separator m-nav__separator--dashed " />

                      <router-link
                        tag="li"
                        :to="{ name: 'Invoicing'}"
                        active-class="m-nav__item--active"
                        class="m-nav__item"
                      >
                        <router-link
                          :to="{ name: 'Invoicing'}"
                          class="m-nav__link"
                        >
                          <i class="m-nav__link-icon flaticon-piggy-bank" />
                          <span class="m-nav__link-title">
                            <span class="m-nav__link-wrap">
                              <span class="m-nav__link-text">{{ $t("menus.user.invoicing") }}</span>
                            </span>
                          </span>
                        </router-link>
                      </router-link>

                      <li
                        active-class="m-nav__item--active"
                        class="m-nav__item"
                      >
                        <a
                          :href="rateCardURL"
                          class="m-nav__link"
                          target="_blank"
                        >
                          <i class="m-nav__link-icon flaticon-piggy-bank" />
                          <span class="m-nav__link-title">
                            <span class="m-nav__link-wrap">
                              <span class="m-nav__link-text">{{ $t("menus.user.rateCard") }}</span>
                            </span>
                          </span>
                        </a>
                      </li>

                      <router-link
                        tag="li"
                        :to="{ name: 'TermsOfService'}"
                        active-class="m-nav__item--active"
                        class="m-nav__item"
                      >
                        <router-link
                          :to="{ name: 'TermsOfService'}"
                          class="m-nav__link"
                        >
                          <i class="m-nav__link-icon flaticon-exclamation-1" />
                          <span class="m-nav__link-title">
                            <span class="m-nav__link-wrap">
                              <span class="m-nav__link-text">{{ $t("menus.user.termsofservice") }}</span>
                            </span>
                          </span>
                        </router-link>
                      </router-link>

                      <router-link
                        tag="li"
                        :to="{ name: 'Support'}"
                        active-class="m-nav__item--active"
                        class="m-nav__item"
                      >
                        <router-link
                          :to="{ name: 'Support'}"
                          class="m-nav__link"
                        >
                          <i class="m-nav__link-icon flaticon-support" />
                          <span class="m-nav__link-text">{{ $t("common.support") }}</span>
                        </router-link>
                      </router-link>

                      <router-link
                        v-if="false"
                        tag="li"
                        :to="{ name: 'FAQ'}"
                        active-class="m-nav__item--active"
                        class="m-nav__item"
                      >
                        <router-link
                          :to="{ name: 'FAQ'}"
                          class="m-nav__link"
                        >
                          <i class="m-nav__link-icon flaticon-exclamation-2" />
                          <span class="m-nav__link-text">{{ $t("common.faq") }}</span>
                        </router-link>
                      </router-link>

                      <li class="m-nav__separator m-nav__separator--dashed " />

                      <li class="m-nav__item">
                        <router-link
                          :to="{ name: 'Logout'}"
                          class="m-nav__link"
                        >
                          <i class="m-nav__link-icon flaticon-logout" />
                          <span class="m-nav__link-text">{{ $t("menus.user.logout") }}</span>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </template>
          </dropdown>
        </li>
        <!-- begin: usermenu -->

        <!-- begin: language -->
        <li
          class="m-nav__item m-topbar__languages m-dropdown m-dropdown--small m-dropdown--header-bg-fill m-dropdown--arrow m-dropdown--align-right  m-dropdown--languages"
        >
          <dropdown>
            <template #btn>
              <span class="m-nav__link-text">
                <img
                  id="language_flag"
                  alt=""
                  class="m-topbar__language-selected-img"
                  :src="currentFlag"
                >
              </span>
            </template>
            <template #dropdown>
              <span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust" />
              <div class="m-dropdown__inner">
                <div
                  class="m-dropdown__header m--align-center"
                  :style="'background-image: url('+cdnURL+'/img/misc/quick_actions_bg_blue.jpg); background-size: cover;'"
                >
                  <span class="m-dropdown__header-subtitle">{{ $t('common.picklanguage') }}</span>
                </div>
                <div class="m-dropdown__body">
                  <div class="m-dropdown__content">
                    <ul class="m-nav m-nav--skin-light">
                      <li
                        v-for="(language, index) of ['en', 'es']"
                        :key="index"
                        :class="{'m-nav__item': true, 'm-nav__item--active': isActiveLanguage(language)}"
                      >
                        <template v-if="!isActiveLanguage(language)">
                          <a
                            href="javascript:"
                            :class="{'m-nav__link':true, 'm-nav__link--active':false}"
                            @click="setLocale(language)"
                          >
                            <span class="m-nav__link-icon">
                              <img
                                class="m-topbar__language-img"
                                alt=""
                                :src="flagFor(language)"
                              >
                            </span>
                            <span class="m-nav__link-title m-topbar__language-text m-nav__link-text">
                              {{ $t('lang.' + language) }}
                            </span>
                          </a>
                        </template>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </template>
          </dropdown>
        </li>
        <!-- begin: language -->
      </ul>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie';
import { getPropertyService, getFeaturedService, onBeforeOpenSwal, getUser } from '../../../../functions.ts';
import { clientapi } from '../../../../api-clients/client-api.js';
import { businesslistingsapi } from '../../../../api-clients/business-listings-api.js';
import { rateCardsURLSByLanguage } from '../../../../common/rates.js';
import Dropdown from '../../../Dropdown.vue';

const flags = {
    es: import.meta.env.TWC_CDN_URL + '/img/flags/spain.svg',
    en: import.meta.env.TWC_CDN_URL + '/img/flags/uk.svg',
};

export default {
    name: 'TopBar',
    components: {
        Dropdown,
    },
    data() {
        return {
            cdnURL: import.meta.env.TWC_CDN_URL,
            user: {},
            propertyService: {},
            featuredService: {},
            businessListings: [],
            drafts: [],
            languages: [],
        };
    },
    computed: {
        rateCardURL() {
            return rateCardsURLSByLanguage[ this.$i18n.locale || 'es' ];
        },
        noFeaturedProperty() {
            return this.propertyService.Status === 'ACTIVE' && this.featuredService.MaxFeaturedPremium === 0 && this.featuredService.MaxFeaturedStandard === 0;
        },
        noFeaturedBusiness() {
            return this.businessListings && this.businessListings.length > 0 && this.businessListings.some( ( x ) => x.active && !x.adInfo.isFeatured && !x.adInfo.isFeaturedPremium );
        },
        firstLetter() {
            let user = this.user;
            if ( !user || !user.Name || user.Name.length === 0 ) {
                return '?';
            }

            return user.Name[ 0 ];
        },
        numberOfNotifications() {
            let count = 0;
            if ( this.noFeaturedProperty ) {
                count++;
            }
            if ( this.noFeaturedBusiness ) {
                count++;
            }

            if ( this.drafts.length > 0 ) {
                count++;
            }
            return count;
        },
        fullName() {
            if ( !this.user ) {
                return '?';
            }

            if ( this.user.TradeName ) {
                return this.user.TradeName;
            }

            if ( this.user.CompanyName ) {
                return this.user.CompanyName;
            }

            return '?';
        },
        email() {
            return this.user.Email;
        },
        login() {
            return this.user.Login;
        },
        currentFlag() {
            return flags[ this.$i18n.locale || 'es' ];
        },
        getLinkToProperties() {
            let queryCopy = this.$utils.cloneObject( this.$route.query );
            queryCopy[ 'action' ] = 'openPI';
            if ( this.$route.name === 'Properties' ) {
                return { name: 'Properties',
                    query: queryCopy };
            }

            return { name: 'Properties',
                query: {
                    action: 'openPI',
                } };
        },
        canSeeProperty() {
            let status = this.propertyService.Status;
            return [ 'ACTIVE', 'ACTIVE_PENDING', 'ACTIVE_EXPIRED' ].includes( status );
        },
    },
    async mounted() {
        this.user = getUser();

        const businessListingsCall = new Promise( async ( resolve ) => {
            if ( !this.user || !this.user.Login ) {
                return;
            };

            const params = new URLSearchParams();
            params.set( 'take', 50 );
            params.set( 'agents', this.user.Login );
            params.set( 'includeInactive', true );

            const result = await businesslistingsapi.get( `/listings?${params.toString()}` );

            if ( result.status !== 200 ) {
                swal( {
                    title: this.$t( 'error.AnErrorOccurred' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
            } else {
                this.businessListings = result.data.results;
            }

            resolve();
        } );

        let propertyServiceCall = getPropertyService();
        let featuredServiceCall = getFeaturedService();

        this.getDrafts();

        this.propertyService = await propertyServiceCall;
        await businessListingsCall;
        this.featuredService = await featuredServiceCall;
    },
    methods: {
        flagFor( lang ) {
            return flags[ lang ];
        },
        isActiveLanguage( codeLang ) {
            return this.$i18n.locale === codeLang;
        },
        setLocale: function( locale ) {
            Cookie.set( 'locale', locale, { expires: 14,
                sameSite: 'Strict' } );
            this.$i18n.locale = locale;
            this.$router.go();
        },
        async getDrafts() {
            let response = await clientapi.get( '/items', { params: { type: 'new-property' } } );

            if ( response.status !== 200 ) {
                return;
            }

            if ( response.data ) {
                this.drafts = response.data.filter( ( r ) => r.Content !== null );
            }
        },
        orderStickerLink() {
            const params = new URLSearchParams();

            if ( this.user && this.user.Login ) {
                params.set( 'login', this.user.Login );
            }

            return `https://www.thinkspain.com/${this.$i18n.locale === 'es' ? 'es/' : ''}order-window-stickers?` + params.toString();
        },
    },
};
</script>
